import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Switch, Button, Card, CardContent } from '@mui/material';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const AppDownloadInfo = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [appleStoreLink, setAppleStoreLink] = useState('');
  const [googlePlayLink, setGooglePlayLink] = useState('');
  const [appleEnabled, setAppleEnabled] = useState(false);
  const [googleEnabled, setGoogleEnabled] = useState(false);

  useEffect(() => {
    const a = settings.custom?.appDownload;
    if (!a) return;
    if (a.appleStoreLink !== undefined) setAppleStoreLink(a.appleStoreLink);
    if (a.googlePlayLink !== undefined) setGooglePlayLink(a.googlePlayLink);
    if (a.appleEnabled !== undefined) setAppleEnabled(a.appleEnabled);
    if (a.googleEnabled !== undefined) setGoogleEnabled(a.googleEnabled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleAppleStoreLinkChange = (event) => {
    setAppleStoreLink(event.target.value);
  };

  const handleGooglePlayLinkChange = (event) => {
    setGooglePlayLink(event.target.value);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { appDownload: { appleStoreLink, googlePlayLink, appleEnabled, googleEnabled } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
          <CardContent>
            <Typography sx={{ mb: 1.25 }} variant="h6" color="text.primary">Apple Store</Typography>
            <TextField
              fullWidth
              label="Download Link"
              value={appleStoreLink}
              onChange={handleAppleStoreLinkChange}
            />
            <Switch checked={appleEnabled} onChange={(e) => setAppleEnabled(e.target.checked)} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
          <CardContent>
            <Typography sx={{ mb: 1.25 }} variant="h6" color="text.primary">Google Play Store</Typography>
            <TextField
              fullWidth
              label="Download Link"
              value={googlePlayLink}
              onChange={handleGooglePlayLinkChange}
            />
            <Switch checked={googleEnabled} onChange={(e) => setGoogleEnabled(e.target.checked)} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save App Download Info'}
        </Button>
      </Grid>

      <SaveSnackbar snack={snack} onClose={closeSnack} />
    </Grid>
  );
};

export default AppDownloadInfo;
